import ATGBasketService from '../implementations/ATGBasketService';
import MockBasketService from '../implementations/MockBasketService';
import ODMBasketService from '../implementations/ODMBasketService';
import { BasketServiceInterface } from '../interface/BasketServiceInterface';
import BasketService from '../BasketService';

export enum BasketServiceType {
  ATG = 'ATG',
  MOCK = 'MOCK',
  ODM = 'ODM',
}

export default class BasketServiceFactory {
  static createBasketService(type: BasketServiceType = BasketServiceType.ATG): BasketService {
    let service: BasketServiceInterface;

    switch (type) {
      case BasketServiceType.MOCK:
        service = new MockBasketService();
        break;
      case BasketServiceType.ODM:
        service = new ODMBasketService();
        break;
      default:
        service = new ATGBasketService();
    }

    return new BasketService(service);
  }

  static getBasketServiceType({
    basketMockEnabled,
    amendBasketEnabled,
  }: {
    basketMockEnabled: boolean;
    amendBasketEnabled: boolean;
  }): BasketServiceType {
    if (basketMockEnabled) return BasketServiceType.MOCK;

    if (amendBasketEnabled) return BasketServiceType.ODM;

    return BasketServiceType.ATG;
  }
}
